// ********************** BODY **************************** \\
const disableScroll = () => {
  document.body.classList.add("no-scroll");
};

const enableScroll = () => {
  document.body.classList.remove("no-scroll");
};

const scrollToTop = () => {
  window.scrollTo(0, 1);
};
